<template>
  <div class="real-time-alarm margin-top-20">
    <el-col style="font-size: 0.9rem;">
      <el-row>
        <ul class="row-ul">
          <li class="row-li ml-4">
            <el-checkbox-group v-model="checkboxGroupLevel" size="small">
              <el-checkbox-button v-for="level in alarmLevel" :key="level.id" :label="level.levelName"
                @touchstart.native.prevent="handleLevelSearch(level)" @click.native.prevent="handleLevelSearch(level)"></el-checkbox-button>
            </el-checkbox-group>
          </li>
          <li class="row-li ml-4">
            <el-checkbox-group v-model="checkboxGroupTags" size="small">
              <el-checkbox-button v-for="city in citiesTags" :key="city.id" :label="city.name"
                @touchstart.native.prevent="handleTagsSearch(city)"  @click.native.prevent="handleTagsSearch(city)"></el-checkbox-button>
            </el-checkbox-group>
          </li>
          <li class="mr-0 ml-4 row-li">
            <el-checkbox-group v-model="checkboxGroupDate" size="small">
              <el-checkbox-button v-for="city in citiesDate" :key="city.value" :label="city.name"
                @touchstart.native.prevent="quickTimeSelection(city)"   @click.native.prevent="quickTimeSelection(city)"></el-checkbox-button>
            </el-checkbox-group>
          </li>
          <li v-if="checkboxGroupDate.indexOf('自定义')!==-1" class="ml-0 row-li customTime">
            <el-date-picker
              v-model="screenDate"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              size="mini"
              start-placeholder="开始日期"
              style="width: 100%; height: 30px;margin-top: 1px;"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="formChange">
            </el-date-picker>
          </li>
        </ul>
        <ul class="row-ul">
          <li class="row-li ml-4">
            <el-checkbox v-model="defaultForm.isGatewayOffline" style="color: #FFFFFF;" @change.native="refresh(1)">
              只看主机离线告警
            </el-checkbox>
          </li>
        </ul>
        <ul class="row-ul ad-search"
            style="float: right!important;margin-right: 20px;padding-top: 20px;padding-bottom: 10px;">
          <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="float: right">
            <a type="text" size="mini" @touchstart="() => {this.seniorQuery = !this.seniorQuery}"  @click="()=>{this.seniorQuery = !this.seniorQuery}"
               style="color:#299FFB; margin-top: 10px;cursor: pointer;">
              {{ this.seniorQuery ? '关闭' : '' }}高级搜索
              <i :class="this.seniorQuery?'el-icon-arrow-up el-icon--right':'el-icon-arrow-down el-icon--right'"></i>
            </a>
          </el-col>
        </ul>
      </el-row>
      <el-row>
        <ul class="row-ul" v-if="this.seniorQuery">
          <li class="row-li  ml-4">
            <div class="d-inline-block" style="width: 80px;">空间：</div>
            <el-cascader
              v-model="realTimeForm.space"
              :options="spaces"
              change-on-select="true"
              clearable
              collapse-tags
              filterable
              placeholder="请选择"
              size="mini"
              class="pr-5"
              style=" width: 240px;">
            </el-cascader>
          </li>
          <li class="row-li  ml-4">
            <div class="d-inline-block" style="width: 80px;">设备类型：</div>
            <el-select
              v-model="realTimeForm.category"
              collapse-tags
              multiple
              placeholder="请选择"
              size="mini"
              class="pr-5"
              style="width: 240px;">
              <el-option
                v-for="item in deviceCategory"
                :key="item.id"
                :label="item.cnName"
                :value="item.id">
              </el-option>
            </el-select>
          </li>
        </ul>
        <ul class="row-ul" v-if="this.seniorQuery">
          <li class="row-li  ml-4">
            <div class="d-inline-block" style="width: 80px;">设备名称：</div>
            <el-autocomplete
              v-model="realTimeForm.equipmentName"
              :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb,this.devices,'deviceByName')"
              class="inline-input pr-5"
              placeholder="请输入设备名称"
              size="mini"
              style=" width: 240px;"
            ></el-autocomplete>
          </li>
          <li class="row-li  ml-4">
            <div class="d-inline-block" style="width: 80px;">告警内容：</div>
            <el-autocomplete
              v-model="realTimeForm.msg"
              :fetch-suggestions="(queryString, cb) => querySearch(queryString, cb,this.records,'msg')"
              class="inline-input"
              placeholder="请输入告警内容"
              size="mini"
              style=" width: 205px;"
            ></el-autocomplete>
          </li>
        </ul>
        <ul class="row-ul" style="float: right!important;margin-right: 30px;margin-top: 5px;" v-if="this.seniorQuery">
          <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="float: right">
            <el-button size="mini" :loading="isSelect"
                       style="float:right;font-weight:bold;padding:9px 25px;color:rgba(7, 230, 248, 1)"
                       @touchstart.native="filtrateForm"
                       @click.native="filtrateForm">查询
            </el-button>
          </el-col>
        </ul>
      </el-row>
      <el-row>
        <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24"
                style="border-bottom: 1px solid rgba(41, 155, 255, .2);">
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px;margin-left: 20px;margin-right: 30px;">
        <el-button class="button" size="mini" style="float: left;height: 30px;" @touchstart="batchAlarmHandling" @click="batchAlarmHandling">批量处理
        </el-button>
        <el-button class="button" size="mini" style="float: left;height: 30px;" @touchstart="batchAlarmElimination" @click="batchAlarmElimination">批量消警
        </el-button>
        <el-button class="button" size="mini" style="float: left;height: 30px;" icon="el-icon-refresh"
              @touchstart.native="refreshData"     @click.native="refreshData" :loading="isRefresh">刷新
        </el-button>

        <el-button class="button" size="mini" style="float: right; margin-bottom: 10px;height: 30px"
              @touchstart="openDialog"     @click="openDialog">
          <span style="color: #299FFB">下载列表</span>
        </el-button>
        <el-button class="button" size="mini" style="float: right; margin-bottom: 10px;height: 30px"
              @touchstart="toAlarmHistory"     @click="toAlarmHistory">
          <span style="color: #299FFB">查看历史告警</span>
        </el-button>

        <el-popover placement="bottom" width="300" trigger="click" popper-class="popoverSetColumnClass"
                    style="float: right">
          <el-checkbox-group v-model="colOptions">
            <el-checkbox style="width: 100px" v-for="item in colSelect" :label="item" :key="item"></el-checkbox>
          </el-checkbox-group>
          <el-button size="mini" style="float: right; margin-bottom: 10px;height: 30px;margin-left: 10px"
                     slot="reference">
            <img src="../../assets/images/icon/设置.png" alt="" style="width: 70%;margin-bottom: 4px;">
          </el-button>
        </el-popover>
        <el-button class="button" size="mini" style="float: right; margin-bottom: 10px;height: 30px"
                @touchstart.native="exportExcel"   @click.native="exportExcel" :loading="isDownload">
          <img src="../../assets/images/icon/excel.png" alt="" style="margin-bottom: 4px;">
          <span style="margin-left: 5px;color: #299FFB">导出</span>
        </el-button>
        <tableComponent :table-columns="tableColumns" :table-data="tableData" :tickSystem="tickSystem"
                        @changeCheckBoxValue="changeCheckBoxValue" @alarmHandling="alarmHandling"
                        @alarmElimination="alarmElimination" @viewLog="viewLog"
                        @videoLinkageButton="videoLinkageButton" @handleToView="handleToView"></tableComponent>
      </el-row>
      <el-row style="margin-top: 15px;text-align: center;" v-if="dateTotal>10">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="defaultForm.pageCurrent"
          :page-size="defaultForm.pageSize"
          :total="dateTotal">
        </el-pagination>
      </el-row>
    </el-col>
    <alarm-handling :visible="deviceDialogVisible"
                    :title="title"
                    :alarmId="id"
                    :code="code"
                    :idList="idList"
                    opinion=""
                    :activities="activities"
                    @getData="getData(defaultForm)"
                    @dialogClose="(data) => this.deviceDialogVisible = data"></alarm-handling>

    <!--    弹出告警信息-->

    <alarm-information :visible="videoLinkage"
                       :videoType="videoType"
                       :startVideoLinkage="startVideoLinkage"
                       :latestAlarmInformation="latestAlarmInformation"
                       @alarmInformationVisible="(data) => this.videoLinkage = data"></alarm-information>
    <dialog-component
      dialog-title="下载列表"
      :closeClick="false"
      :dialogVisible.sync="dialogVisible"
      width="65vw"
      @dialogClose="(data) => this.dialogVisible = data">
      <div slot="content" style="height:70vh;padding: 20px 30px">
        <div class="text-right">
          <el-button size="mini" @touchstart="deleteAllInfo()" @click="deleteAllInfo()">清空</el-button>
        </div>
        <el-table
          :data="DownLoadTableData"
          :height="'55vh'"
          class="table"
          style="width: 100%;margin-top: 10px;">
          <el-table-column
            align="center"
            label="名称"
            prop="name">
          </el-table-column>
          <el-table-column
            align="center"
            label="时间"
            prop="createTime">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态"
            prop="status">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">
                <i class="el-icon-loading"
                   style="font-size: 1.2rem;margin-right: 5px;font-weight: bolder;"></i>
                正在加载中</span>
              <span v-if="scope.row.status === 2">
                <i class="el-icon-close"
                   style="font-size: 1.2rem;margin-right: 5px;font-weight: bolder;color: red;margin-top:3px;"></i>
                导出失败</span>
              <span v-if="scope.row.status === 1" style="color: #58E039">
                <i class="el-icon-check"
                   style="font-size: 1.2rem;margin-right: 5px;font-weight: bolder;">
                </i> 加载完成
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="文件名"
            prop="fileName">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <i class="el-icon-download text-blue pointer"
                 @touchstart="exportExcel1(scope.row.fileUrl)"
                 @click="exportExcel1(scope.row.fileUrl)"
                 v-if="scope.row.status === 1"
                 style="margin-right: 10px;font-size: 1.3rem;">
              </i>
              <i class="el-icon-download text-grey"
                 v-else
                 style="margin-right: 10px;font-size: 1.3rem;cursor: not-allowed">
              </i>

              <i class="el-icon-delete text-red pointer"
                 @touchstart="deleteInfoById(scope.row.id)"
                 @click="deleteInfoById(scope.row.id)"
                 style="font-size: 1.2rem"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="margin-top: 15px;text-align: center;" v-if="DownLoadTableData.length">
          <el-pagination
            :current-page.sync="form.pageCurrent"
            :page-size="form.pageSize"
            :total="dataTotal"
            @current-change="handleExportCurrentChange"
            background
            layout="prev, pager, next">
          </el-pagination>
        </el-row>
      </div>
    </dialog-component>
    <iframe frameborder="0" ref="downExcel" style="display:none"></iframe>
  </div>
</template>

<script>
import AlarmHandling from "./AlarmHandling";
//import {downloadBlobFile} from '@/constant/export-file';
import {dateFormat, exportToExcel, getInfo, getMsgList, unique} from '@/network/alarm-realtime';
import {getListByParentCode} from '@/network/extension';
import {getAllChildId, getSpaceTreeData} from '@/network/space-info';
import {getLevelList} from "@/network/alarm-level";
import {getDeviceCategoryList} from "@/network/device-category";
import {getDeviceByName} from "@/network/device-info";
import {getType} from "@/constant/alarm-type";
import {listByRecordId, packageList} from "@/network/alarm-log";
import AlarmInformation from "@/components/AlarmInformation";
import {isEnableByDeviceId} from "@/network/device-linkage";
import {getSystematicByCodes} from "@/network/systematic";
import TableComponent from "@/components/TableComponent";
import DialogComponent from "@/components/DialogComponent";
import {
  deleteDownloadAllInfo,
  deleteDownloadInfoById,
  getExtDownloadList
} from "../../network/ext-download-record";
// import Template from "@/views/basic_operations/sys_setting/sms_template/Template";

const quickDate = [{name: '全部', value: -1}, {name: '当天', value: 0}, {name: '近一周', value: 7}, {
  name: '近一个月',
  value: 31
}, {name: '近一年', value: 365}, {name: '自定义', value: -2}];
export default {
  name: "RealTimeAlarm",
  components: {AlarmHandling, AlarmInformation, TableComponent, DialogComponent},
  data() {
    return {
      videoLinkage: false,
      videoType: 'realTimeAlarm',
      startVideoLinkage: false,
      latestAlarmInformation: {},
      activities: [],
      // 告警等级默认选中
      checkboxGroupLevel: ['全部'],
      // 标签默认选中
      checkboxGroupTags: ['全部'],
      checkboxGroupDate: ['全部'],
      citiesTags: [{
        id: '-1',
        name: '全部'
      }],
      isSelect: false,
      isDownload: false,
      isRefresh: false,
      checked: false,
      radioDate: "",
      citiesDate: quickDate,
      seniorQuery: false,
      title: "",
      code: "",
      diaWidth: "",
      diaHeight: "",
      id: "",
      idList: [],
      deviceDialogVisible: false,
      //表单参数
      realTimeForm: {
        // 告警内容
        msg: '',
        space: '',
        equipmentName: '',
        category: []
      },
      // 时间选择器绑定值
      screenDate: '',
      // 当前翻页采用参数
      defaultForm: {
        msg: '',
        space: [],
        equipmentType: [],
        //当前页数
        pageCurrent: 1,
        // 每页数
        pageSize: 10,
        levelId: 0,
        //设备名称
        equipmentName: '',
        equipmentLabelList: [],
        startDate: '',
        endDate: '',
        isGatewayOffline: false
      },
      content: '',
      // 选中的告警等级名称
      level: '',
      // 空间下拉数据
      spaces: [],
      // 设备类型下拉数据
      deviceCategory: [],
      alarmLevel: [{
        id: '0',
        levelName: '全部',
        levelColor: ''
      }],
      //时间
      value: '',
      // 表单设备标签默认值
      tag: [],
      // 表单空间默认值
      space: [],
      // 列表数据
      tableData: [],
      // 列表总数
      dateTotal: 0,
      // 告警内容？
      records: [],
      // 设备名称
      devices: [],
      codes: ['tick_system'],
      tickSystem: true,
      colOptions: [], // 选中项
      colSelect: [], // 可选项
      // field对应数据返回的字段名，title对应列头名，isShow代表这列是否显示
      tableColumns: [
        {field: 'checkBox'},
        {field: 'type', title: "告警类型", isShow: true, formatter: this.typeFormat, align: 'center'},
        {field: 'deviceName', title: "设备名称", isShow: true, align: 'center'},
        {field: 'pointName', title: "测点名称", isShow: true, align: 'center'},
        {field: 'levelId', title: "告警级别", isShow: true, align: 'center'},
        {field: 'msg', title: "内容", width: '300', isShow: true, align: 'center'},
        {field: 'createTime', title: "告警时间", isShow: true, align: 'center'},
        {field: 'ticketNo', title: "工单编号", isShow: true, align: 'center'},
        {field: 'isProcess', title: "状态", isShow: true, formatter: this.stateFormat, align: 'center'}
      ],
      dialogVisible: false,
      DownLoadTableData: [],
      form: {
        pageCurrent: 1,
        pageSize: 10,
      },
      dataTotal: 0,
    }
  },
  watch: {
    // 监听colOptions值的变化
    colOptions(valArr) {
      localStorage.setItem("realTimeAlarmColSelect", JSON.stringify(valArr)) // 将修改结果放入本地缓存
      var arr = this.colSelect.filter(i => valArr.indexOf(i) < 0); // 未选中
      // 将未选中的isShow改成false
      this.tableColumns.filter(i => {
        if (arr.indexOf(i.title) !== -1) {
          i.isShow = false;
        } else {
          i.isShow = true;
        }
      });
      // 刷新表格
      this.$nextTick(() => {
        // this.$refs.refTable.doLayout();
      });
    }
  },
  mounted() {
    this.getByCodes();
    this.getLevel().then(() => {
      // 大屏跳转过来
      let params = this.defaultForm;
      if (this.$route.query.id) {
        params.id = this.$route.query.id;
      }
      if (this.$route.query.levelId) {
        params.levelId = this.$route.query.levelId;
        const levelItem = this.alarmLevel.find(item => item.id === this.$route.query.levelId);
        if (levelItem) {
          this.checkboxGroupLevel = [levelItem.levelName];
        }
      }
      // 获取数据
      this.getData(params);
    });
    
    // 监听声音开关事件，刷新数据
    this.$root.$on('refreshAlarmData', () => {
      this.getData(this.defaultForm);
    });
    
    // 历史查询
    let searchHistory = this.$store.getters.getSearchHistory;
    // 有历史查询
    if (searchHistory !== undefined && searchHistory != null && searchHistory.length > 0) {
      this.records = this.assemblyArray(searchHistory.toString().split(','));
    } else {
      this.records = [];
    }
    getDeviceByName().then(res => {
      if (res.code === 0) {
        let nameList = [];
        if (res.data != null) {
          for (let item of res.data) {
            nameList.push({value: item.name});
          }
          if (nameList.length > 0) {
            this.devices = unique(nameList);
          }
        }
      }
    });
  },
  created() {
    var _this = this;
    let columnList = localStorage.getItem("realTimeAlarmColSelect"); // 初始化从本地缓存中获取，如果有，则用缓存中的数据
    for (let i = 0; i < _this.tableColumns.length; i++) {
      // 去掉checkbox的自定义列
      if (_this.tableColumns[i].field.indexOf('checkBox') !== -1) {
        continue
      }
      _this.colSelect.push(_this.tableColumns[i].title);
      // 初始化不想展示的列可以放在这个条件里
      if (columnList != null && columnList.length > 0) {
        if (columnList.indexOf(_this.tableColumns[i].title) === -1) {
          continue
        }
      }
      _this.colOptions.push(_this.tableColumns[i].title);
    }
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getRealTime');
    // 移除事件监听
    this.$root.$off('refreshAlarmData');
  },
  methods: {
    //查询工单系统是否开启
    getByCodes() {
      getSystematicByCodes(this.codes).then(res => {
        if (res.code === 0) {
          res.data.forEach(item => {
            if (item.code === "tick_system") {
              this.tickSystem = Boolean(item.val1);
            }
          })
        }
      })
    },

    changeCheckBoxValue: function (val) {
      this.idList = [];
      for (let i = 0; i < val.length; i++) {
        let id = val[i].id;
        this.idList.push(id);
      }
    },
    // 高级筛选
    filtrateForm() {
      // 组装表单
      this.defaultForm.pageCurrent = 1;
      this.defaultForm.pageSize = 10;
      this.defaultForm.msg = this.realTimeForm.msg;
      this.defaultForm.equipmentName = this.realTimeForm.equipmentName;
      if (this.realTimeForm.category !== undefined && this.realTimeForm.category.length > 0) {
        this.defaultForm.equipmentType = this.realTimeForm.category;
      } else {
        this.defaultForm.equipmentType = [];
      }
      var space = this.realTimeForm.space.length > 0 ? this.realTimeForm.space[this.realTimeForm.space.length - 1] : '';
      // 获取空间下的所有子空间
      if (space.length > 0) {
        getAllChildId(space).then(res => {
          if (res.code === 0) {
            // 将树转换成需要的格式
            this.space = res.data;
            this.space.push(space);
            this.defaultForm.space = this.space;
            this.getData(this.defaultForm);
          }
        })
      } else {
        this.defaultForm.space = [];
        this.getData(this.defaultForm);
      }
      if (this.defaultForm.msg.length > 0) {
        var newMsg = this.defaultForm.msg;
        let search = this.$store.getters.getSearchHistory;
        if (search !== undefined && search.length > 0) {
          let nameList = [];
          if (search) {
            for (let item of search.toString().split(",")) {
              nameList.push(item);
            }
            if (nameList.length > 0) {
              nameList.push(newMsg);
            }
            this.$store.commit('setSearchHistory', nameList);
          }
        }
        this.$store.commit('setSearchHistory', newMsg)
      }
    },
    // 翻页
    handleCurrentChange(val) {
      //当前为第几页时调用getData()显示第几页数据
      this.defaultForm.pageCurrent = val;
      this.defaultForm.pageSize = 10;
      this.getData(this.defaultForm);
    },
    // 修改告警等级
    handleLevelSearch(val) {
      this.defaultForm.pageCurrent = 1;
      this.defaultForm.pageSize = 10;
      this.defaultForm.levelId = val.id;
      this.checkboxGroupLevel = [val.levelName];
      this.getData(this.defaultForm);
    },
    // 修改设备标签
    handleTagsSearch(val) {
      this.defaultForm.pageCurrent = 1;
      this.defaultForm.pageSize = 10;
      this.defaultForm.equipmentLabelList = [val.id];
      if (val.id === -1) {
        this.defaultForm.equipmentLabelList = [];
      }
      this.checkboxGroupTags = [val.name];
      this.getData(this.defaultForm);
    },
    refreshData() {
      this.isRefresh = true;
      this.getData(this.defaultForm);
    },
    refresh(current) {
      if (current !== undefined) {
        this.defaultForm.pageCurrent = 1;
      }
      this.getData(this.defaultForm);
    },
    // 获取数据
    getData(params) {
      this.isSelect = true;
      this.clearData();
      getInfo(params).then(res => {
        this.clearData();
        if (res.code === 0) {
          // 列表数据
          let bln = res.data == null;
          this.tableData = bln ? [] : res.data.records;
          // 总数
          this.dateTotal = bln ? 0 : res.data.total;
          // 每页数
          this.defaultForm.pageSize = bln ? 10 : res.data.size;
          this.defaultForm.pageCurrent = bln ? 1 : res.data.current;
        }
        this.isRefresh = false;
        this.isSelect = false;
      });
      if (params.id) {
        this.$router.push("/realTime-alarm")
        this.defaultForm.id = null
      }
    },
    // 清空数据
    clearData() {
      this.tableData = [];
      // 总数
      this.dateTotal = 0;
    },
    // 获取告警类型
    typeFormat(data) {
      let type = data.type;
      return getType(type);
    },
    // 状态
    stateFormat(data) {
      let isProcess = data.isProcess;
      let isConfirm = data.isConfirm;
      let message = isConfirm == true ? "处理中," + (isProcess == true ? "已消警" : "未消警") : "未处理," + (isProcess == true ? "已消警" : "未消警");
      return message;
    },
    // 获取告警级别
    getLevel() {
      return new Promise((resolve) => {
        getLevelList().then(res => {
          if (res.code === 0) {
            this.alarmLevel = this.alarmLevel.concat(res.data);
          }
          this.getTags();
          resolve();
        }).catch(err => {
          console.error('获取告警级别失败:', err);
          resolve(); // 即使出错也继续
        });
      });
    },
    // 获取设备标签
    getTags() {
      getListByParentCode("device_category_tag").then(res => {
        if (res.code === 0) {
          res.data = res.data.filter(item => item.isDisplay);
          this.citiesTags = this.citiesTags.concat(res.data);
        }
      })
      this.getDeviceCategoryList();
    },
    // 获取设备类型
    getDeviceCategoryList() {
      getDeviceCategoryList().then(res => {
        if (res.code === 0) {
          this.deviceCategory = res.data;
        }
      });
      this.getSpaceTreeData();
    },
    getSpaceTreeData() {
      getSpaceTreeData().then(res => {
        if (res.code === 0) {
          // 将树转换成需要的格式
          let tree = res.data;
          this.spaces = this.getTree(tree);
        }
      });
    },
    // 传入一个数组
    getTree(tree) {
      // 返回的数组
      let treeList = [];
      for (let item of tree) {
        // 创建上级选项
        let param = {value: item.id, label: item.title};
        if (item.children) {
          // 给上级选项添加下级选项
          param.children = this.getTree(item.children);
        }
        treeList.push(param)
      }
      return treeList;
    },
    assemblyArray(data) {
      let nameList = [];
      if (data != null) {
        for (let item of data) {
          nameList.push({value: item});
        }
        if (nameList.length > 0) {
          return unique(nameList);
        }
      }
    },
    querySearch(queryString, cb, params, type) {
      // 输入停止1s后执行
      var len = queryString.length;
      if (queryString.length === len) {
        // 向远处获取数据 并加入到列表中
        if (type === 'deviceByName') {
          // 获取设备名称
          getDeviceByName(this.realTimeForm.space[this.realTimeForm.space.length - 1], this.realTimeForm.category, queryString).then(res => {
            if (res.code === 0) {
              let nameList = [];
              if (res.data != null) {
                for (let item of res.data) {
                  nameList.push({value: item.name});
                }
                if (nameList.length > 0) {
                  this.devices = unique(nameList);
                }
              }
              cb(nameList);
            }
          });
        } else if (type === 'msg') {
          if (queryString.length === 0) {
            // 历史查询
            let searchHistory = this.$store.getters.getSearchHistory;
            // 有历史查询
            if (searchHistory !== undefined && searchHistory != null && searchHistory.length > 0) {
              this.records = this.assemblyArray(searchHistory.toString().split(','));
            }
            cb(this.records);
          } else {
            // 获取告警内容
            let param = {
              msg: queryString
            };
            getMsgList(param).then(res => {
              if (res.code === 0) {
                let msgList = [];
                if (res.data != null) {
                  for (let msg of res.data) {
                    msgList.push({value: msg});
                  }
                  this.records = unique(msgList);
                }
                cb(this.records);
              }
            });
          }
        }
        // setTimeout(() => {
        //   const records = params;
        //   const results = queryString ? records == null ? "" : records.filter(this.createFilter(queryString)) : records;
        //   // 调用 callback 返回建议列表的数据
        //   cb(results);
        // }, 2000);
      }
    },
    createFilter(queryString) {
      return (records) => {
        // 存在即建议
        return (records.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
      };
    },
    //告警处理
    alarmHandling(id) {
      this.deviceDialogVisible = true;
      this.code = "1";
      this.title = "告警处理";
      this.diaWidth = "60%";
      this.diaHeight = "30vh";
      this.id = id;
    },
    //批量告警处理
    batchAlarmHandling() {
      if (this.idList.length > 0) {
        this.deviceDialogVisible = true;
        this.code = "5";
        this.title = "批量告警处理";
        this.diaWidth = "60%";
        this.diaHeight = "30vh";
      } else {
        this.$message({
          message: '请先选择要批量处理的告警',
          type: 'warning'
        });
      }
    },
    //消警
    alarmElimination(id) {
      this.deviceDialogVisible = true;
      this.code = "2";
      this.title = "消警";
      this.diaWidth = "60%";
      this.diaHeight = "30vh";
      this.id = id;
    },
    //批量消警
    batchAlarmElimination() {
      if (this.idList.length > 0) {
        this.deviceDialogVisible = true;
        this.code = "6";
        this.title = "批量消警";
        this.diaWidth = "60%";
        this.diaHeight = "30vh";
      } else {
        this.$message({
          message: '请先选择要批量消除的告警',
          type: 'warning'
        });
      }
    },
    //告警日志
    viewLog(row) {
      this.code = "3";
      this.title = "告警日志";
      this.diaWidth = "60%";
      this.diaHeight = "60vh";
      let id = row.alarmRecordId;
      listByRecordId(id, false).then(res => {
        this.activities = packageList(res.data, row.ticketNo);
        this.deviceDialogVisible = true;
      });
    },

    //视频联动
    videoLinkageButton(row) {
      //判断该设备是否有启动的联动视频
      isEnableByDeviceId(row.deviceId).then(res => {
        if (res.code === 0) {
          this.startVideoLinkage = res.data;
          this.latestAlarmInformation = row;
          this.videoLinkage = true;
          console.log("实时告警信息：", this.latestAlarmInformation, this.startVideoLinkage);
        }
      });

    },
    // 跳转到空间概览
    handleToView(row) {
      this.$router.push({
        path: '/overview',
        query: {
          spaceId: row.spaceId,
          tagId: row.tagId,
          tagName: row.tagName,
          deviceId: row.deviceId,
          spaceName: row.spaceName,
        }
      })

    },
    quickTimeSelection(val) {
      var days = val.value;
      this.checkboxGroupDate = [val.name];
      if (days >= 0) {
        const end = new Date();
        const start = new Date();
        end.setTime(end.getTime() + 3600 * 1000 * 24);
        start.setTime(start.getTime() - 3600 * 1000 * 24 * days);
        this.screenDate = [start, end];
      } else {
        this.screenDate = [];
      }
      if (this.checkboxGroupDate.indexOf('自定义') == -1) {
        this.formChange();
      }
    },
    toAlarmHistory() {
      // let routeUrl = this.$router.resolve({path: '/historical/alarm-history'});
      // window.open(routeUrl.href, '_blank')
      this.$router.push({
        path: '/historical/alarm-history'
      })
    },
    // excel导出
    exportExcel() {
      this.isDownload = true;
      let exportForm = this.defaultForm;
      exportForm.pageCurrent = 1;
      exportForm.pageSize = 10000;
      this.$message.info('文件生成中，稍后请前往下载列表中下载文件!')
      exportToExcel(exportForm).then(res => {
        this.isDownload = false;
        if (res) {
          /*downloadBlobFile(res, "实时告警数据" + dateFormat(new Date(), "yyyyMMdd"));*/
        }
      });
    },
    // 变动数据改变 获取数据
    formChange() {
      // 组装表单
      // 设置开始时间
      if (this.screenDate != null && this.screenDate.length > 0) {
        let startTime = this.screenDate[0];
        let endTime = this.screenDate[1];
        console.log(startTime);
        this.defaultForm.startDate = dateFormat(startTime, "yyyy-MM-dd");
        // 设置结束时间
        this.defaultForm.endDate = dateFormat(endTime, "yyyy-MM-dd");
      } else {
        this.defaultForm.startDate = '';
        // 设置结束时间
        this.defaultForm.endDate = '';
      }
      this.defaultForm.pageCurrent = 1;
      this.defaultForm.pageSize = 10;
      this.realTimeForm = this.defaultForm;
      this.getData(this.defaultForm);
    },
    openDialog() {
      this.dialogVisible = true
      this.form.pageCurrent = 1
      this.getExtDownloadList()
    },
    handleExportCurrentChange(val) {
      this.form.pageCurrent = val;
      this.form.pageSize = 10;
      this.getExtDownloadList();
    },
    // 获取可下载列表
    getExtDownloadList() {
      getExtDownloadList(this.form.pageCurrent, this.form.pageSize).then(res => {
        if (res.code === 0) {
          this.DownLoadTableData = res.data.records;
          this.form.pageCurrent = res.data.current;
          this.form.pageSize = res.data.size;
          this.dataTotal = res.data.total;
        }
      })
    },
    deleteInfoById(id) {
      deleteDownloadInfoById(id).then(res => {
        if (res.code === 0) {
          this.$message.success("删除成功")
          this.form.pageCurrent = 1
          this.getExtDownloadList();
        }
      })
    },
    deleteAllInfo() {
      // 提示读值
      this.$confirm('确定清空吗？', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            deleteDownloadAllInfo().then(res => {
              if (res.code === 0) {
                this.$message.success("清空成功")
                this.form.pageCurrent = 1
                this.getExtDownloadList();
              } else {
                this.$message.error(res.message)
              }
            })
          }
        }
      })
    },
    //导出
    exportExcel1(fileUrl) {
      let iframe = this.$refs.downExcel;
      const href = window.g.ftpUrl + fileUrl;//接口路径地址，返回数据类型为application/binary，后台控制显示信息，前端仅为下载功能
      console.log(href);
      iframe.src = href
      /* this.isDownload = true;
       if (this.date1) {
         exportEnergy(this.date1).then(res => {
           this.isDownload = false
           if (res.code === 0) {
             let iframe = this.$refs.downExcel;
             const href = window.g.ftpUrl + res.data;//接口路径地址，返回数据类型为application/binary，后台控制显示信息，前端仅为下载功能
             iframe.src = href
           } else {
             this.$message.error(res.message)
           }
         }).catch(err => {
           this.isDownload = false;
           this.$message.error("下载失败");
         });
       } else {
         this.isDownload = false;
         this.$message.warning("请选择日期");
       }*/
    }
  }
}
</script>
<style scoped>
.ulClass {
  padding-left: 25px;
  list-style: none;
}

.liClass {
  list-style: none;
  padding: 0;
  float: left;
}

.row-li {
  margin: 5px;
  line-height: 30px;
  list-style: none;
  padding: 0;
  float: left !important;
}

.row-ul {
  list-style: none;
  padding: 0;
  /*padding-top: 10px;*/
  margin-bottom: 0 !important;
  float: left !important;
}

@media (max-width: 500px ) {
  .timeSlotChoice {
    float: none;
  }
}

@media (max-width: 1274px) {
  .ad-search {
    margin-top: 0 !important;
  }
}

@media (max-width: 440px) {
  .customTime {
    padding-left: 18px !important;
  }
}

/*@media (max-width: 927px) {*/
/*  .customTime {*/
/*    padding-left: 0px!important;*/
/*  }*/
/*}*/
@media (max-width: 1250px) {
  .customTime {
    padding-left: 18px;
  }
}

@media (max-width: 1290px) {
  .customTime {
    padding-left: 18px;
  }
}
</style>
<style>
.popoverClass {
  background: #083966;
  border: 1px solid #083966;
  text-align: center;
}

.el-button {
  color: #fff;
  font-size: 0.9rem;
  background-color: rgba(41, 155, 255, .2);
  border: none;
}

.el-button:hover {
  background-color: rgba(41, 155, 255, .4) !important;
  color: #fff;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #FFFFFF;
}

.popoverSetColumnClass {
  background: #083966;
  border: 1px solid #083966;
  text-align: left;
  padding-left: 1%;
}

.el-popper[x-placement^=bottom] .popper__arrow::after {
  border-bottom-color: #083966;
}

.el-popper[x-placement^=bottom] .popper__arrow {
  border-bottom-color: #083966;
}
</style>
